module.exports = __webpack_public_path__ + "static/media/icon-fb.1e49b809.svg";